let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c1Jhp")).then(() => parcelRequire('fx0qT'));